// extracted by mini-css-extract-plugin
module.exports = {"hero":"franchising-module--hero--1QlpH","content":"franchising-module--content--zINS0","button":"franchising-module--button--v-ni9"};